<script lang="ts">
	type SocialPlatform = 'facebook' | 'instagram' | 'linkedin' | 'telegram' | 'twitter' | 'whatsapp';
	type IconSize = 'small' | 'medium';

	interface Props {
		href: string;
		platform: SocialPlatform;
		size?: IconSize;
	}

	let { href, platform, size = 'medium' }: Props = $props();
</script>

<a {href} aria-label={platform}>
	<div class={`social ${platform} ${size}`}>
		<i class={`icon icon-social-${platform} ${size}`}></i>
	</div>
</a>

<style lang="postcss">
	@reference '../app.css';

	.social {
		@apply bg-gray-mid inline-flex aspect-square items-center justify-center rounded-full text-center hover:opacity-90;

		& > i {
			@apply text-white-pure inline-flex items-center;
		}

		&.small {
			@apply w-6;

			& > i {
				@apply h-6 text-sm;
			}
		}

		&.medium {
			@apply w-10;

			& > i {
				@apply h-10 text-2xl;
			}
		}
	}

	.facebook {
		background-color: #1877f2;
	}

	.linkedin {
		background-color: #0077b5;
	}

	.telegram {
		background-color: #54a9eb;
	}

	.instagram {
		background: -webkit-radial-gradient(
			30% 107%,
			circle,
			#fdf497 0%,
			#fdf497 5%,
			#fd5949 45%,
			#d6249f 60%,
			#285aeb 90%
		);
		background: -o-radial-gradient(
			30% 107%,
			circle,
			#fdf497 0%,
			#fdf497 5%,
			#fd5949 45%,
			#d6249f 60%,
			#285aeb 90%
		);
		background: radial-gradient(
			circle at 30% 107%,
			#fdf497 0%,
			#fdf497 5%,
			#fd5949 45%,
			#d6249f 60%,
			#285aeb 90%
		);
		background: -webkit-radial-gradient(
			circle at 30% 107%,
			#fdf497 0%,
			#fdf497 5%,
			#fd5949 45%,
			#d6249f 60%,
			#285aeb 90%
		);
	}

	.twitter {
		background-color: #1da1f2;
	}

	.whatsapp {
		background-color: #25d366;
	}
</style>
